import * as yup from 'yup';
import * as Constants from './constants';

export const ValidationSchema = yup.object().shape({
  password: yup.string().required('Password is required'),
  passwordConfirmation: yup.string()
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
});
